import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from 'prop-types';
import {setShouldRefresh } from "store/state/companies";
import { withRouter} from "react-router-dom";
import { VersitileInput } from "components/Global/Fields/VersitileInput";
import { TableCell, TableHead, TableBody, Table, TableRow, TableFooter, TablePagination, Button } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search"
import styled from "styled-components";
import {join} from 'lodash';
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

const StyledHeaderCell = styled(TableCell)`
  && {    
    font-size: 17px;
    color: black;
    background-color: #fff;    
    padding:0 8px;
  }  
`;

const StyledTableRow = styled(TableRow)`
  && {    
    padding:4px 8px;
  }
`;

const PaginationBar = styled(TableRow)`
  &&& {    
    padding:4px 8px;
    background:#fff;
    border-left: 1px solid rgba(224, 224, 224,0.4);
    border-right: 1px solid rgba(224, 224, 224,0.4);
    border-bottom: 1px solid rgba(224, 224, 224,0.4);
  }
  &&:hover {
    background:#fff !important;
  }
`;

const StyledBodyCell = styled(TableCell)`
  && {
    padding:0 8px;
  }
`;

export class CompaniesTable extends Component {
  state = {    
    selected: [],
    data: [], // reserved for sorted list
    searchText: null, 
  };

  tablePaginationHelper = new TablePaginationHelper("338e8052-26ab-4caa-b527-52dba1ac6205", 10);

  columns = [
    {
      id: "companyName",
      numeric: false,
      label: "Company Name",
      Cell: ({ company: { name } }) => {
        const nameStyle = {
          minWidth:400
        }
        return (<StyledBodyCell style={nameStyle}>{name}</StyledBodyCell>
        )
      }
    },
    {
      id: "companyType",
      numeric: false,
      label: "Company Type",
      Cell: ({ company: { companyTypes } }) => {
        const companyTypeNames = companyTypes && companyTypes.map(x => x.name);
        const companyStyle = {
          minWidth: 400
        };
        return (
          <StyledBodyCell style={companyStyle}>
            {join(companyTypeNames, " | ")}
          </StyledBodyCell>
        );
      }
    },
    {
      id: "actions",
      numeric: false,
      label: "Actions",
      actions: true,
      Cell: ({ company: { id } }) => {
        const actionStyle = {
          minWidth:200
        }
        return (<StyledBodyCell style={actionStyle}>
          <Button
            onClick={e => this.props.onEditCompany(e, id)}
            className="button_TableActions _loansListEdit">
            <EditIcon />
          </Button>
        </StyledBodyCell>
        )
      }
    }
  ];
  
  componentDidUpdate(prevProps, prevState, snapshot){       
    const {shouldRefresh} = this.props;
    if(shouldRefresh){
      this.props.retrievePage({
        page: this.tablePaginationHelper.page,
        limit: this.tablePaginationHelper.rowsPerPage,
        searchText: this.state.searchText,
      });
      this.props.setShouldRefresh(false);
    }
  }

  getRows = companies => 
    companies.map(company => (
      <TableRow key={company.id} hover>
        {this.columns.map(({ id, Cell }) => <Cell key={id} company={company} />)}
      </TableRow>
    ));  

  handleChangePage = (event, newPage) => {
    if (event) {
      this.tablePaginationHelper.page = newPage;
      this.props.retrievePage({
        page: this.tablePaginationHelper.page,
        limit: this.tablePaginationHelper.rowsPerPage,
        searchText: this.state.searchText
      });
    }
  };

  handleChangeRowsPerPage = event => {
    this.tablePaginationHelper.rowsPerPage = event.target.value;

    this.props.retrievePage({
      limit: this.tablePaginationHelper.rowsPerPage,
      searchText: this.state.searchText,
    });
  };

  render() {
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const page = this.tablePaginationHelper.page;
    const { companies, count } = this.props;    
    if(!companies){
      return null;
    }        
    
    return (
      <Fragment>
        <div style={{display:"inline-block", float: 'right', marginRight: "30px"}}>
          <VersitileInput 
            internalLabel= "Search"
            style = {{maxWidth: "300px", width:"300px"}}
            inputProps = {{
              onKeyDown: e => { if(e.keyCode === 13) {
                this.props.retrievePage({
                  page,
                  limit: rowsPerPage,
                  searchText: this.state.searchText,
                });
              } 
            },
            }}
            onChange = {value => {
              this.setState({
                searchText: value,
              });
            }}
          />      
          <SearchIcon style={{cursor: "pointer"}} onClick = {()=>{ 
            this.props.retrievePage({
                page,
                limit: rowsPerPage,
                searchText: this.state.searchText,
              })}}/>  
        </div>
        <Table className="tableBlueHover">
          <TableHead>
            <StyledTableRow>              
              <StyledHeaderCell>Company Name</StyledHeaderCell>
              <StyledHeaderCell>Company Type</StyledHeaderCell>              
              <StyledHeaderCell>Actions</StyledHeaderCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>{this.getRows(companies)}</TableBody>
          <TableFooter>
            <PaginationBar>
              <TablePagination
                colSpan={10}
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                onChangePage={(event, newPage) => this.handleChangePage(event, newPage)}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
              />
            </PaginationBar>
          </TableFooter>
        </Table>        
      </Fragment>
    );
  }
}

CompaniesTable.propTypes = {
    onEditCompany: PropTypes.func.isRequired,
    retrievePage: PropTypes.func.isRequired,
    count: PropTypes.number
}

const mapStateToProps = ({ authentication,companies }) => ({
  authentication,  
  shouldRefresh: companies.shouldRefresh
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    {setShouldRefresh}      
  )
)(CompaniesTable);
